export default __webpack_public_path__ + "static/media/icon_fit_Standard.ff7a309c.png";